class CartABTest {
  constructor() {
    this.storageKey = 'cart_ab_test_group';
    this.group = this.getOrAssignGroup();
    this.initTracking();
  }

  getOrAssignGroup() {
    const stored = localStorage.getItem(this.storageKey);
    if (stored && ['A', 'B', 'C', 'D'].includes(stored)) {
      return stored;
    }

    const groups = ['A', 'B', 'C', 'D'];
    const randomIndex = Math.floor(Math.random() * groups.length);
    const newGroup = groups[randomIndex];
    
    localStorage.setItem(this.storageKey, newGroup);
    return newGroup;
  }

  initTracking() {
    this.updateURL();
    this.sendToGA4();
    this.applyGroupSettings();
  }

  updateURL() {
    const url = new URL(window.location.href);
    url.searchParams.set('cart_variant', this.group);
    window.history.replaceState({}, '', url);
  }

  sendToGA4() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'cart_ab_test_assigned', {
        'experiment_group': this.group,
        'experiment_name': 'cart_trust_features'
      });
    }

    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        'event': 'cart_variant_assigned',
        'cart_variant_group': this.group
      });
    }
  }

  applyGroupSettings() {
    document.documentElement.setAttribute('data-cart-variant', this.group);
    
    const features = {
      'A': 'secure_badge',
      'B': 'warranty_badge', 
      'C': 'trust_reviews',
      'D': 'warranty_item'
    };

    window.cartABTestFeature = features[this.group];
    
    this.hideOtherFeatures(features[this.group]);
  }

  hideOtherFeatures(activeFeature) {
    const featureSelectors = {
      'secure_badge': '.cart-secure-badge',
      'warranty_badge': '.cart-warranty-badge',
      'trust_reviews': '.cart-trust-reviews',
      'warranty_item': '.cart-warranty-item'
    };

    Object.entries(featureSelectors).forEach(([feature, selector]) => {
      const elements = document.querySelectorAll(selector);
      if (feature !== activeFeature) {
        elements.forEach(el => el.style.display = 'none');
      } else {
        elements.forEach(el => el.style.display = '');
      }
    });
  }

  trackCartOpen() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'cart_opened', {
        'experiment_group': this.group,
        'experiment_name': 'cart_trust_features'
      });
    }
  }

  trackCheckoutClick() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'begin_checkout', {
        'experiment_group': this.group,
        'experiment_name': 'cart_trust_features'
      });
    }
  }
}

window.cartABTest = new CartABTest();

document.addEventListener('DOMContentLoaded', () => {
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'aria-hidden') {
          if (cartDrawer.getAttribute('aria-hidden') === 'false') {
            window.cartABTest.trackCartOpen();
            window.cartABTest.applyGroupSettings();
          }
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }

  const checkoutBtn = document.querySelector('button[name="checkout"]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.cartABTest.trackCheckoutClick();
    });
  }
});